export default function DifferentiatorSection() {
  const differentiators = [
    {
      icon: 'ri-test-tube-line',
      title: '바이럴 DNA',
      description: '단순한 광고가 아닌, 자연스럽게 공유되고 확산되는 콘텐츠를 만듭니다.'
    },
    {
      icon: 'ri-global-line',
      title: '글로벌 마인드셋',
      description: '한국을 넘어 전세계 게이머들의 마음을 사로잡는 콘텐츠를 제작합니다.'
    },
    {
      icon: 'ri-chat-voice-line',
      title: '소문의 힘',
      description: '소문처럼 퍼져나가는 개발사의 스트레스를 줄이고, 게임이 자연스럽게 전세계에 퍼져나가도록 돕습니다.'
    },
    {
      icon: 'ri-rocket-line',
      title: '빠른 확산',
      description: '검증된 바이럴 전략으로 게임이 빠르게 확산되도록 만듭니다.'
    }
  ];

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Dark background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f0f0f] via-black to-[#1a1a1a]"></div>
      
      {/* Atmospheric lighting */}
      <div className="absolute top-0 left-1/3 w-[500px] h-[500px] bg-[#F6B766]/4 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-0 right-1/3 w-[500px] h-[500px] bg-[#F4A259]/4 rounded-full blur-[120px]"></div>

      <div className="relative z-10 container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center mb-6">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#F6B766]/50"></div>
            <span className="mx-4 text-[#F6B766]/70 text-sm tracking-[0.3em] uppercase">Why MondayPawn</span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#F6B766]/50"></div>
          </div>
          
          <h2 className="text-5xl lg:text-6xl font-light text-white mb-6">
            우리만의 <span className="text-[#F6B766]">차별점</span>
          </h2>
          <p className="text-xl text-white/60 max-w-3xl mx-auto font-light leading-relaxed">
            전당포 골목의 지혜로 게임을 세계에 퍼뜨리는 특별한 방법
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {differentiators.map((item, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#F6B766]/20 to-[#F4A259]/10 rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-[#F6B766] text-3xl`}></i>
              </div>
              <h3 className="text-xl font-light text-white mb-3">{item.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom statement */}
        <div className="mt-24 text-center">
          <div className="max-w-4xl mx-auto">
            <p className="text-3xl text-white/80 font-light leading-relaxed mb-8">
              "당신의 게임을 전세계에 <span className="text-[#F6B766]">퍼뜨려드립니다</span>"
            </p>
            <p className="text-white/50 font-light">
              조용히 시작되어 세계를 움직이는 확산의 힘을 믿습니다
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
